const messages0 = [
  {
    id: 1,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'Welcome to Water Town!',
    read: false,
    content: [
      'As the operator you’re responsible for managing the water supply of the town. You do this by controlling the flow of water via three water pumps.',
      'Water demand will fluctuate throughout the day so sometimes you won’t need any pumps running and sometimes you might need all three pumps running. Pumps cost a lot to run, and power rates go up and down through the day.',
      '<b>We need to keep our running costs low</b> and the townsfolk happy. Let’s keep the water at a healthy level and keep the pumps well maintained.',
      'Let’s quickly run through the software.'
    ],
    time: 0,
    buttons: [
      {
        className: '',
        label: 'Let\'s Go',
        reset: true,
        action: 'startTutorial'
      },
      {
        className: 'action-disabled',
        label: 'Skip',
        action: 'skipTutorial',
        challenge: 1
      }
    ]
  },
  {
    id: 2,
    status: null,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'You\'ve completed your training tutorial, well done!',
    read: false,
    content: [
      'You are now ready to start your first day. If you get stuck you can always come back here and replay the tutorial.',
      'Remember; keep the town happy and keep your costs as low as possible!'
    ],
    time: 5.2 * 3600,
    buttons: [
      {
        className: '',
        label: 'Play',
        action: 'goToChallenge',
        challenge: 1
      },
      {
        className: 'action-disabled',
        label: 'Restart Tutorial',
        reset: true,
        action: 'startTutorial'
      }
    ]
  }
]

const messages1 = [
  {
    id: 11,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'Welcome to Water Town!',
    read: false,
    content: [
      'As the operator you’re responsible for managing the water supply of the town. You do this by controlling the flow of water via three water pumps.',
      'Water demand will fluctuate throughout the day so sometimes you won’t need any pumps running and sometimes you might need all three pumps running. Pumps cost a lot to run, and power rates go up and down through the day.',
      '<b>We need to keep our running costs low</b> and the townsfolk happy. Let’s keep the water at a healthy level and keep the pumps well maintained.',
      'Let’s quickly run through the software.'
    ],
    time: 0,
    buttons: [
      {
        className: '',
        label: 'Let\'s Go',
        reset: true,
        action: 'startTutorial'
      },
      {
        className: 'action-disabled hide-on-start',
        label: 'Skip',
        action: 'skipTutorial',
        challenge: 1
      }
    ]
  },
  {
    id: 10,
    from: 'Town Mayor',
    icon: 'icon-mayor',
    subject: null,
    read: false,
    content: [
      'Hello there,',
      'This is the Mayor of Water Town here just wanting to welcome you to the community.',
      'You have an important job, so please take good care of our water supply!',
      'All the best,',
      'Mayor'
    ],
    time: 3600 * 0.2,
    buttons: [
    ]
  },
  {
    id: 13,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'Keep an eye out for problem signs with the pumps.',
    read: false,
    content: [
    ],
    time: 3600 * 3.5,
    buttons: [
    ]
  },
  {
    id: 15,
    from: 'Town Mayor',
    icon: 'icon-mayor',
    subject: 'Water demand is a bit lower when it rains, higher when is sunny',
    read: false,
    content: [
    ],
    time: 3600 * 8,
    buttons: [
    ]
  },
  {
    id: 16,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'Thank you for your hard work',
    read: false,
    content: [
    ],
    time: 3600 * 23,
    buttons: [
    ]
  }
]

const messages2 = [
  {
    id: 22,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'Pump Analytics',
    read: false,
    content: [
      'We’ve just come across analytics from GE Digital, which predict pump failure, avoid unplanned downtime and reduce costs. Could save us a lot of money and a lot of stress too.',
      'Costs $125 per pump but I think it\'ll save us that and more pretty quickly.',
      'Which pumps should we get Analytics for?',
      {
        buttons: [
          'Pump 1', 'Pump 2', 'Pump 3'
        ]
      }
    ],
    time: 0,
    buttons: [
      {
        className: 'purchase-button hide-on-start',
        label: 'Continue',
        action: 'purchaseAnalyticsCh2'
      }
    ]
  },
  {
    id: 26,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'It’s going to be a really hot sunny day, lots of water demand',
    read: false,
    content: [
    ],
    time: 3600 * 11,
    buttons: [
    ]
  }
]

const messages3 = [
  {
    id: 31,
    from: 'Supervisor',
    icon: 'icon-supervisor',
    subject: 'Welcome to Challenge 3!',
    read: true,
    content: [
      'We had a lot of problems in the night and the pumps are showing the strain, be careful today.',
      'We encourage you to purchase analytics, it’ll avoid unplanned downtime, saving you costs and unnecessary stress.',
      {
        buttons: [
          'Pump 1', 'Pump 2', 'Pump 3'
        ]
      }
    ],
    time: 0,
    buttons: [
      {
        className: 'purchase-button hide-on-start',
        label: 'Continue',
        action: 'purchaseAnalyticsCh3'
      }
    ]
  },
  {
    id: 32,
    from: 'Maintenance Manager',
    icon: 'icon-pumpengineer',
    subject: 'Pump 2 needs repairing',
    read: false,
    content: [
    ],
    time: 3600 * 0.2,
    buttons: [
    ]
  },
  {
    id: 33,
    from: 'Town Mayor',
    icon: 'icon-mayor',
    subject: 'We’ve got crazy weather today!',
    read: false,
    content: [
    ],
    time: 3600 * 3,
    buttons: [
    ]
  }
]

const messages = [
  messages0,
  messages1,
  messages2,
  messages3
]

const deliveredMessages = []
let pendingMessages = JSON.parse(JSON.stringify(messages[0]))

const messageListeners = []

export default {
  currentChallenge: 0,
  reset: function () {
    deliveredMessages.splice(0, deliveredMessages.length)
    pendingMessages = JSON.parse(JSON.stringify(messages[this.currentChallenge]))
    for (const idx in messageListeners) {
      messageListeners[idx](null)
    }
  },
  deliverMessage: function (msg) {
    deliveredMessages.unshift(msg)
    for (const idx in messageListeners) {
      messageListeners[idx](msg)
    }
  },
  addMessageListener: function (callback) {
    if (messageListeners.indexOf(callback) === -1) {
      messageListeners.push(callback)
    }
  },
  unread: function () {
    let unread = 0
    for (const idx in deliveredMessages) {
      if (!deliveredMessages[idx].read) {
        unread++
      }
    }
    return unread
  },
  deliverMessages: function (time) {
    let msg = pendingMessages[0]
    let count = 0
    while (msg && msg.time <= time) {
      pendingMessages.splice(0, 1)
      this.deliverMessage(msg)
      msg = pendingMessages[0]
      count++
    }
    return count
  },
  list: deliveredMessages,
  messages: messages
}
